import React from 'react'
import PropTypes from 'prop-types'
import styles from './Card.scss'

const Card = ({ children }) => {
  return <div className={styles.Wrapper}>{children}</div>
}

export default Card

Card.propTypes = {
  children: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Form/Card/Cards.js